import React, { Component } from 'react';
import Modal from './Modal';
import Spinner from './Spinner';

var downloadSvg = require('!svg-inline-loader!../../../public/img/download.svg');

class ExportModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            exportFullClicked: false
        };
        this.showModal = this.showModal.bind(this);
        this.exportFull = this.exportFull.bind(this);
    }
    
    showModal(show) {
        this.setState({
            showModal: show !== undefined ? show: !this.state.showModal
        })
    }
    
    exportFull(){
        this.setState({
            exportFullClicked: true
        }, ()=>{
            this.props.exportFull();
        })
    }

    render() {
        const { exportTotals, exportBreakdown, exportFull, loading = false, totalsLabel = 'Current View', breakdownLabel = 'Breakdown', fullLabel = 'Full Export (emailed)' } = this.props;
        const { exportFullClicked } = this.state;
        
        return <div className="export-modal-holder">
            <Modal show={this.state.showModal} 
                title="Export Data" 
                showActionButtons={false}
                // size="sm"
                handleClose={()=>this.showModal(false)}
            dialogClassName="entity-filter-modal" 
            >
                {!exportFullClicked && <p className="export-modal">
                    <a className="export-modal-link" onClick={()=>exportTotals()}>{totalsLabel}</a>
                    {exportBreakdown && <a className="export-modal-link" onClick={()=>exportBreakdown()}>{breakdownLabel}</a>}
                    {exportFull && <a className="export-modal-link" onClick={()=>this.exportFull()}>{fullLabel}</a>}
                    <Spinner enabled={loading} />
                </p>}
                {exportFullClicked && <p className="export-modal">
                    <span className="popup-confirm-text">Your export is scheduled. Check your inbox for an email from reports@entertainment-intelligence.com</span>
                </p>}
            </Modal>
            <a key="download" title="Export" onClick={()=>this.showModal(true)} className="download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />
        </div>
    }
}
export default ExportModal;